import LoyaltyNativeBalanceSFC from "./LoyaltyNativeBalance.vue";
export const LoyaltyNativeBalance = LoyaltyNativeBalanceSFC;
